
import React, { useState } from 'react'
import { useAuth } from '../context/AuthContext';
import { MoSpan, MoContainer, Alert, Button, Input, ButtonTypes, MoLink } from '../Mo7/mo7UI';
import { icons } from '../services/design.sevice';

export default function ForgotPassword() {
    const [{ email }, setInputValues] = useState({ email: "" })
    //Error and messages
    const [error, setError] = useState("")
    const [message, setMessage] = useState("")
    const [loading, setLoading] = useState(false)


    const { resetPassword } = useAuth()
    function handleInputChange(e) {
        const { name, value } = e.target;
        setInputValues((prev) => ({
            ...prev, [name]: value
        }))
    }

    async function handleSignup(e) {
        e.preventDefault();
        //signin here
        var success = false;
        try {
            setError("")
            setMessage("")
            setLoading(true)
            await resetPassword(email)
            success = true

        } catch {
            setError("Failed to reset password")
            success = false
        }

        if (success) {
            setMessage("Check Your email for further instructions")
        } else {
            setLoading(false)
        }
    }
    return (<MoContainer grid  w="100vw" h="100vh">
        <MoContainer flex flex_dir_c align="center" justify="center" w="100vw" >
            <MoSpan>Reset Your Password</MoSpan>
            <form onSubmit={handleSignup}>
                <MoContainer flex flex_dir_c gap="1rem" place="center">

                    <Input type="text" required value={email} onChange={handleInputChange} name="email" pholder="email" icon={icons.ic_email} />
                    <Button pd={{ lr: "1.4rem" }} type={ButtonTypes.outline} title="Reset Password" disabled={loading} />

                    <MoLink m_t="1rem" to="/signin">Sign In </MoLink>
                </MoContainer>
            </form>
            {error && <Alert danger >{error}</Alert>}
            {message && <Alert success >{message}</Alert>}
        </MoContainer>
        <MoContainer m_t="auto" flex align="center" justify="flex-end" pd={{ r: "2rem",b:"2rem" }}>
            <img width="100px" src={icons.logo1} alt="" />
        </MoContainer>
    </MoContainer>
    )
}
